import { InvoicesModule } from '@folio/modules';

export const BrokerPolicyDashboardInvoicesView = () => {
  return (
    <div className="flex flex-col gap-4">
      <InvoicesModule />
    </div>
  );
};
